import { Component, inject } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { TooltipButtonComponent } from '../../../components/button/tooltip-button.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconComponent } from '../../../components/icon/icon.component';
import { OverlayComponent } from '../../../components/overlay/overlay.component';
import { OverlayHeaderComponent } from '../../../components/overlay/overlay-header.component';
import { SecurityService } from '../../../services/security.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-account-selector-tooltip',
  templateUrl: 'account-selector-tooltip.component.html',
  imports: [
    TranslatePipe,
    TranslateDirective,
    TooltipButtonComponent,
    OverlayComponent,
    OverlayHeaderComponent,
    HrefDirective,
    IconComponent
  ]
})
export class AccountSelectorTooltipComponent {
  private readonly securityService = inject(SecurityService);

  readonly showTooltip: boolean = true;

  constructor() {
    this.showTooltip = this.securityService.hasPermission('CUSTOMIZE_SITE');
  }
}
